export { default } from "./TermsMessage";
